module.exports = __webpack_public_path__ + "static/sport/tag-login.45c6c55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/tag-login.png
// module id = er09
// module chunks = 0